<template>
    <div>
        <b-modal v-model="showFileSelector"
            v-on:ok='saveNewFile()'>
            <b-form-file
                id="input-attach-file"
                v-model="file"
                :state="validFile()"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here...">
            </b-form-file>
            <b-form-invalid-feedback id="input-attach-file">
                A file of that name already exists
            </b-form-invalid-feedback>
        </b-modal>
        <b-modal v-model="showDeleteFile"
            v-on:ok='deleteSelectedFile()'
            >
            Do you wish to permanently delete this file?
        </b-modal>
        <div @click="toggleCollapse">
            <h6>Attachments ({{doc_count}})
                <font-awesome-icon 
                    v-if="isEditor"
                    @click.exact="attachFile()"
                    :icon="['fas', 'paperclip']"
                    @click.stop>
                </font-awesome-icon>
            </h6>
        </div>
        <b-collapse v-model="visible">
            <div>
                <b-container class="review-table"> 
                    <b-table :items="documents"
                        :fields="fields">
                        <template v-slot:cell(action)="{ item }">
                            <font-awesome-icon
                                v-if="isEditor" 
                                @click="startDeleteAttachement(item)"
                                :icon="['fas', 'minus-square']">
                            </font-awesome-icon>
                        </template>
                        <template v-slot:cell(file)="{ item: {file, url} }">
                            <b-link :href="url">{{file}} </b-link>
                        </template>
                    </b-table>
                </b-container>
            </div>
        </b-collapse>
    </div>
</template>

<script>

import { mapState } from 'vuex'


export default {
    name: "Attachements",
    props: [
        "reviewer"
    ],
    data() {
        return {
            fields: [
                {
                    key: 'action',
                    label: '',
                },
                {
                    key: 'file',
                    label: 'Document',
                    sortable: true
                }
            ],
            file: null,
            showDeleteFile: false,
            showFileSelector: false,
            visible: false,
            fileToDelete: null,
        }
    },
    computed: {
        ...mapState({
            auditId: state => state.currentAudit.header.id,
            documents: state => state.currentAudit.attachements,
        }),
        doc_count: function() {
            if(this.documents) return this.documents.length
            return 0
        },
        isEditor: function() {
            return !this.reviewer
        }
    },
    methods: {
        toggleCollapse() {
            this.visible = !this.visible
        },
        attachFile() {
            this.showFileSelector = true
        },
        startDeleteAttachement(item) {
            this.fileToDelete = item
            this.showDeleteFile = true
        },
        deleteSelectedFile() {
            if( this.fileToDelete ){
                this.$store.dispatch('currentAudit/deleteAttachement', this.fileToDelete)
            }
            this.fileToDelete = null
        },
        saveNewFile() {
            if(this.validFile()) {
                this.$store.dispatch('currentAudit/attachFile', this.file)
            }
            this.file = null
        },
        validFile() {
            if(this.file) {
                if( this.documents.find(f => f.file == this.file.name)) {
                    return false
                }
                return true
            }
            return null
        },
    },        
}
</script>